<div class="download-dialog">
  <h2 mat-dialog-title>Richiesta inviata!</h2>

  <mat-dialog-content>
    <p>
      Abbiamo ricevuto la tua richiesta.
    </p>

    <div class="success-container">
      <span class="izy-hero-icon">
        <mat-icon class="success-icon">verified</mat-icon>
      </span>
    </div>

    <p class="mt-3 mb-2">
      Cosa devi fare ora?
    </p>

    <!-- Elenco dei passaggi: ogni voce e' una riga con l'icona in petrol
         dentro il riquadro bordato, come le liste informative dell'app. -->
    <div class="info-list">
      <div class="info-item">
        <span class="izy-corner-icon">
          <mat-icon>schedule</mat-icon>
        </span>
        <p>Attendi che la richiesta venga elaborata dai nostri Commercialisti.</p>
      </div>

      <div class="info-item">
        <span class="izy-corner-icon">
          <mat-icon>phone_in_talk</mat-icon>
        </span>
        <p>Contatteremo la persona da te presentata per una call conoscitiva, per assicurarci che abbia tutti i requisiti.</p>
      </div>

      <div class="info-item">
        <span class="izy-corner-icon">
          <mat-icon>discount</mat-icon>
        </span>
        <p>Durante la creazione dell'account, il presentato otterrà un <strong>codice sconto immediato</strong> da usare durante il pagamento del canone annuale.</p>
      </div>

      <div class="info-item">
        <span class="izy-corner-icon">
          <mat-icon>card_giftcard</mat-icon>
        </span>
        <p>Una volta completata la creazione dell'account del presentato, ti invieremo automaticamente una mail con un buono del valore di <strong>30€</strong>, da spendere subito.</p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="izy-dialog-actions">
    <button
      mat-raised-button
      matButton="filled"
      type="button"
      class="izy-button-primary custom-button-border"
      (click)="confirm()">
      <mat-icon>check</mat-icon>
      Fatto!
    </button>
  </mat-dialog-actions>
</div>
